import React from "react";
import "./Footer.css";
import Logo from "../Header/Logo";

const Footer = () => {
  return (
    <footer className="Footer--Container">
      <div className="Footer--Top">
        <div className="Footer--Logo">
          <Logo />
        </div>
      </div>
      <div className="Footer--Bottom">
        <div className="Footer--Meta">
          <p className="Footer--Copyright">
            © {new Date().getFullYear()} Шахризада
          </p>
          <p className="Footer--Small">Все права защищены.</p>
        </div>

        <div className="Footer--Credits">
          <p className="Footer--Small">
            Сайт разработан{" "}
            <a
              className="Footer--Link"
              href="https://t.me/saturnskyline"
              target="_blank"
              rel="noreferrer"
            >
              АНО «ЦЦТ «Горизонт Сатурна» РС(Я)
            </a>{" "}
            и Березин Н. С.
          </p>
          <p className="Footer--Small">
            Поддержка и сопровождение сайта выполняются Березин Н. С.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
